/**
 * 交通问答Mixin
 */
export default {
    methods: {
        /**
        * 交通大模型提问-prompt是发给ai的提示语，input是用户输入的内容，prompt是发给机器人的内容，answerPrefix是回答前缀（用于限定返回内容用什么进行处理）
        */
        trafficAsk (ask) {
            let { input, prompt, nospeech } = ask;
            let useLLM = this.useLLM;
            let askData = prompt + `Question:${input}`;

            // 新增对话记录
            this.addAsk(input, prompt);

            // 文字提问
            // let msg = {
            //     'ask': askData,
            //     'useLLM': useLLM,
            //     'type': 'TEXT',
            //     contextLimit: this.modelSettings.contextLimit,
            //     temperature: this.modelSettings.temperature,
            //     maxLength: this.modelSettings.maxLength
            // };
            // this.socket.send(msg);

            let sseMsg = {
                'message': askData,
                'model': useLLM,
                contextLimit: this.modelSettings.contextLimit,
                temperature: this.modelSettings.temperature,
                maxTokens: this.modelSettings.maxLength
            };

            // 开始等待打字
            this.ui.typing = true;
            this.currentChat.messages.push({ role: 'assistant', content: '', nospeech });
            // this.socket.send(msg);
            this.sendSseStream(sseMsg);
        }
    }
};
